import { GzInputErrorWebComponent } from './component/GzInputErrorWebComponent';
import { WEB_COMPONENT_GZ_INPUT_ERROR } from '../../../webcomponents.constants';

export { GzInputErrorWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_INPUT_ERROR, GzInputErrorWebComponent);
